export enum ApplyProcessSteps {
  ApplyForm = 'ApplyForm',
  ContactInformation = 'ContactInformation',
  ExistingLoan = 'ExistingLoan',
  SignIn = 'SignIn',
}
